/* global TradeInValuations */

import React, { Component } from "react"
import PropTypes from "prop-types"
import Text from "../../component_library/components/react/Text"
import Link from "../../component_library/components/react/Link"
import styled from "styled-components"

const BlurredText = styled.span`
  text-shadow: 0 0 14px black;
  color: transparent;
`

class EmailVerificationStep extends Component {
  static propTypes = {
    emailVerificationTexts: PropTypes.object,
    buyerEmail: PropTypes.string,
    isTestDriveFlow: PropTypes.bool,
    isGenericLead: PropTypes.bool,
    currency: PropTypes.string,
  }

  state = {
    haventReceivedEmail: false,
  }

  onHaventReceivedEmail = () => {
    this.setState({ haventReceivedEmail: true })
  }

  render() {
    const {
      emailVerificationTexts,
      buyerEmail,
      isTestDriveFlow,
      isGenericLead,
      currency,
    } = this.props
    return (
      <div>
        {isTestDriveFlow || isGenericLead ? (
          " "
        ) : (
          <Text textType="xl" align="center">
            <span>
              {currency || "$"} <BlurredText>000000</BlurredText>
            </span>
          </Text>
        )}
        <Text align="center" textType="xl" fontWeight="600">
          {emailVerificationTexts.headline}
        </Text>
        {this.state.haventReceivedEmail ? (
          <Text textType="body" align="center">
            {emailVerificationTexts.email_not_received_text}
          </Text>
        ) : (
          <React.Fragment>
            <Text align="center" textType="body">
              {isTestDriveFlow
                ? emailVerificationTexts.sent_booking_text
                : emailVerificationTexts.sent_text}{" "}
              {buyerEmail}
              {isTestDriveFlow
                ? emailVerificationTexts.verify_booking_email
                : isGenericLead
                ? emailVerificationTexts.verify_email_generic
                : emailVerificationTexts.verify_email}
            </Text>

            <Link
              textType="body"
              align="center"
              onClick={this.onHaventReceivedEmail}
              underline
            >
              {emailVerificationTexts.havent_received_email}
            </Link>
          </React.Fragment>
        )}
      </div>
    )
  }
}

export default EmailVerificationStep
